import { takeLatest } from 'redux-saga/effects';

import generalActionTypes from './action-types';

function* setTestGeneralSaga() {
  try {
    yield console.log('setTestGeneralSaga');
  } catch (error) {
    console.log(error);
  }
}

function* generalSaga() {
  yield takeLatest(generalActionTypes.SET_TEST_GENERAL, setTestGeneralSaga);
}

export default generalSaga;
